// NOTE: components
import LinkCard from './LinkCard'
import LinkVideo from './LinkVideo'
import InlineLink from './InlineLink'

const linkType = (url: string, href: string) => {
    const videoPlatforms = /(?:https?:\/\/)?(?:www\.)?(youtube\.com|youtu\.be|vimeo\.com|dailymotion\.com)/

    const videoExtensions = /\.(mp4|webm|mov|avi|mkv|flv)(\?.*)?$/i

    if (videoPlatforms.test(url) || videoExtensions.test(url)) {
        return "video"
    }

    if (href && href.toLowerCase() !== 'link' && href.toLowerCase() !== 'url') {
        return 'inline'
    }

    return "blog"
}

const RenderLink = ({ children, href }: any) => {
    const linkDisplayType = linkType(children, href)

    return (
        <>
            {linkDisplayType === 'blog' && <LinkCard link={children} />}
            {linkDisplayType === 'video' && <LinkVideo link={children} />}
            {linkDisplayType === 'inline' && <InlineLink text={children} link={href} />}
        </>
    )
}

export default RenderLink
